/* eslint-disable max-len */
/**
 * English translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    NO_ROWS_MENTIONS: 'No mentions'
  },
  SENTENCE: {
    INSTAGRAM_LINK:
      'You mentioned Prozis on a Instagram Story at {publishedAt}',
    NO_ROWS_MENTIONS: 'You haven\'t mention Prozis on your instagram yet'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
